import ICONS from "../../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import CommonLayout from "../../../../_utils/CommonLayout";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const ScheduleTransactionStepSelectAccount = ({
  txnPayLoad,
  setTxnPayLoad,
  openOwner,
  setOpenOwner,
  isModalOpen,
  setIsModalOpen,
  activeType,
  setActiveType,
  setRemPan,
  setRemAccount,
  setRemIFSC,
  remPan,
  remAccount,
  remIFSC,
  handleOwnerSelection,
  handleAccountSelection,
  isConfidential,
  setIsConfidential,
}) => {
  return (
    <>
      <div className="max-w-tab-width-normal w-width-full mx-auto py-padding-md px-padding-md Qlg:px-padding-base">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={openOwner}
              setModalOpen={setOpenOwner}
              txnPayLoad={txnPayLoad}
              setTxnPayLoad={setTxnPayLoad}
              shouldShowAssociatedAccounts={false}
              handleOnAccountSelection={handleOwnerSelection}
            />
          </div>

          <div
            className={`w-width-full lg:max-w-[var(--create-box-width)] ${
              !txnPayLoad?.ownerBankAccountNo
                ? "opacity-light-opacity pointer-events-none"
                : "opacity-base-opacity"
            }`}
          >
            <SourceDestinationAccountDetail
              type="destination"
              flow="beneficiary"
              modalOpen={isModalOpen}
              setModalOpen={setIsModalOpen}
              txnPayLoad={txnPayLoad}
              setTxnPayLoad={setTxnPayLoad}
              shouldShowAssociatedAccounts={false}
              handleOnAccountSelection={handleAccountSelection}
              activeType={activeType}
              setActiveType={setActiveType}
              setRemPan={setRemPan}
              setRemAccount={setRemAccount}
              setRemIFSC={setRemIFSC}
              remIFSC={remIFSC}
              remAccount={remAccount}
              remPan={remPan}
              flowType="scheduleCreate"
            />
          </div>

          <div className="flex flex-col gap-gap-md w-width-full lg:max-w-[var(--create-box-width)]">
            <NameFieldCard
              title={globalTextFormat(globalText?.SCHEDULE_NAME, [0, 1])}
              placeholder={globalText?.NAME}
              note={globalText?.SCHEDULE_NOTE_MIN_LENGTH}
              fieldName="schedule_name"
              minLength={GlobalConfiguration?.lengthCheckFive}
              mode="strict"
              value={txnPayLoad?.scheduleName}
              onChange={(val) =>
                setTxnPayLoad({
                  ...txnPayLoad,
                  scheduleName: val,
                })
              }
            />

            <ConfidentialCard
              icon={ICONS?.CONFIDENTIAL_TRANSACTION}
              title={globalText?.CREATE_AS_CONFIDENTIAL}
              note={globalText?.CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE}
              toggleState={isConfidential}
              onToggle={() => setIsConfidential(!isConfidential)}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default ScheduleTransactionStepSelectAccount;
